import React from 'react';
import { useForkRef } from '../../../utils/useForkRef';
import { block } from '../../../utils/cn';
import { Icon } from '../../../Icon';
import { Chevron } from '../../../icons/Chevron';
import './SelectControl.css';
const b = block('select');
export const SelectControl = React.forwardRef((props, ref) => {
    const { setActive, onKeyDown, renderControl, view, size, pin, optionsText, width, className, name, label, placeholder, active, disabled, } = props;
    const controlRef = React.useRef(null);
    const handleControlRef = useForkRef(ref, controlRef);
    const showOptionsText = Boolean(optionsText.length);
    const showPlaceholder = Boolean(placeholder && !showOptionsText);
    const mods = Object.assign({ view,
        size,
        pin,
        disabled,
        active }, (typeof width === 'string' && { width }));
    const inlineStyles = {};
    if (typeof width === 'number') {
        inlineStyles.width = width;
    }
    const handleClick = React.useCallback(() => setActive(!active), [setActive, active]);
    if (renderControl) {
        return renderControl({
            onKeyDown,
            onClick: handleClick,
            ref: handleControlRef,
        });
    }
    return (React.createElement("button", { ref: handleControlRef, name: name, className: b(mods, className), style: inlineStyles, "aria-haspopup": "listbox", disabled: disabled, onClick: handleClick, onKeyDown: onKeyDown, type: "button" },
        label && React.createElement("span", { className: b('label') }, label),
        showPlaceholder && React.createElement("span", { className: b('placeholder') }, placeholder),
        showOptionsText && React.createElement("span", { className: b('option-text') }, optionsText.join(', ')),
        React.createElement(Icon, { className: b('chevron-icon'), data: Chevron })));
});
SelectControl.displayName = 'SelectControl';
